<template>
    <div class="about">
        <div class="top-actions">
            <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
            <el-button type="default" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>

            <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>

            <div class="search-container">
                <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
                <el-button type="default" icon="el-icon-search" @click="showSearchFields =!showSearchFields"></el-button>
            </div>
        </div>
        <div v-if="showSearchFields" class="advanced-search-fields">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="任务ID">
                            <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名">
                            <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="采集源">
                            <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <el-input v-model="searchForm.creationTime" placeholder="请输入创建时间"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-button type="default" @click="handleAdvancedSearch">提交</el-button>
        </div>

        <el-table
                ref="filterTable"
                :data="pagedData"
                :header-cell-style="{color:'#606266',background:'#f5f7fa'}"
                style="width: 100%"
                stripe
                border
                @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="user_id" label="任务id" sortable width="180" column-key="date" :filters="[{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]" :filter-method="filterHandler"></el-table-column>
            <el-table-column prop="source_keyword" label="任务名" width="180"></el-table-column>
           <!-- <el-table-column prop="create_time" label="发布时间" ></el-table-column> -->
            <el-table-column prop="create_time" label="采集时间" ></el-table-column>
            <el-table-column prop="title" label="视频标题" ></el-table-column>
            <el-table-column prop="video_url" label="视频链接" ></el-table-column>
            <el-table-column prop="video_comment" label="线索数" ></el-table-column>
            <el-table-column prop="video_comment" label="评论筛选数" ></el-table-column>

            <!-- 其他列根据需要添加 -->
            <el-table-column label="操作">
                <template slot-scope="scope">

                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="currentPage"
                :page-size="pgSize"
                :total="totalItems"
                @current-change="handlePageChange">
            </el-pagination>
        </div>
        
    </div>
</template>

<script>
import {kuaishou_video,kuaishou_video2,kuaishou_video3,delete_kuaishou_video,kuaishou_video8} from '@/api/ks';
import moment from'moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver'; 

export default {
    data() {
        return {
            currentPage: 1,
            pgSize: 50,
            idx: -1,
            editVisible: false,
            form: {},
            searchQuery: '',
            showSearchFields: false,
            searchForm: {
                taskId: '',
                taskName: '',
                collectionSource: '',
                creationTime: ''
            },
            selectedRows: [],
            tableData: [
                // 这里是表格数据
            ]
        }
    },
    computed: {
        // 根据搜索关键词过滤表格数据
        filteredTableData() {
            if (!this.searchQuery) return this.tableData;
            const query = this.searchQuery.toLowerCase();
            return this.tableData.filter(data => {
                return Object.values(data).some(value => {
                    return String(value).toLowerCase().includes(query);
                });
            });
        },
        // 计算当前页的数据
        pagedData() {
            const start = (this.currentPage - 1) * this.pgSize;
            const end = start + this.pgSize;
            return this.filteredTableData.slice(start, end);
        },
        // 分页总数基于筛选后的数据
        totalItems() {
            return this.filteredTableData.length;
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
         // 根据用户角色获取对应的API
         getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';
            
            // 定义角色与API的映射关系
            const apiMap = {
                'admin': kuaishou_video,
                'manager': kuaishou_video2,
                'zhuzhu': kuaishou_video3,
                 'huolong': kuaishou_video3,
                'buzhi': kuaishou_video3,
                'ruiqi': kuaishou_video3,
                'daolai': kuaishou_video3,
                'yangguang': kuaishou_video3,
                'demo': kuaishou_video3,
                'jinlianan': kuaishou_video3,
                'jinlianan2': kuaishou_video3,
                'dianguang1':kuaishou_video3,
                'dianguang2': kuaishou_video3,
                'dianguang3': kuaishou_video3,
                'demo': kuaishou_video8,
                 

            };
            
            return apiMap[userRole] || kuaishou_video;
        },
        fetchData() {
            const api = this.getApiByRole();
			api().then(response => {
           
            this.tableData = response.data.map(item => ({
                user_id: item.user_id,
                source_keyword: item.source_keyword, 
                stime: item.create_time, 
                create_time: item.create_time, 
                title: item.title, 
                video_comment: item.comment_count,
                video_comment: item.comment_count, 
                video_url: item.video_url,
                
            }));
        }).catch(error => {
            console.error('获取数据时出错！', error);
        });
        },

        handleExport() {
        if (this.selectedRows.length === 0) {
            this.$message.warning('请先选择要导出的行！');
            return;
        }

        const dataToExport = this.selectedRows.map(item => {
            
            return {
                "任务id": item.user_id,
                "任务名": item.source_keyword,
                "发布时间": item.create_time,
                "采集时间": item.create_time,
                "视频标题": item.title,
                "视频链接":item.video_url,
                "线索数": item.video_comment,
                "评论筛选数": item.video_comment,
                // 根据实际表格列，补充完整其他需要导出的字段
            };
        });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, '导出数据.xlsx');
},
        handleRefresh() {
            this.fetchData();
        },
        handleAdvancedSearch() {
            const params = {
                taskId: this.searchForm.taskId,
                taskName: this.searchForm.taskName,
                collectionSource: this.searchForm.collectionSource,
                creationTime: this.searchForm.creationTime
            };
            kuaishou_video(params).then(response => {
                this.tableData = response.data;
			
            }).catch(error => {
                console.error('There was an error performing advanced search!', error);
            });
            this.showSearchFields = false;
        },
        handleDeleteSelected() {
            const userIds = this.selectedRows.map(row => row.user_id);
        Promise.all(userIds.map(id => delete_kuaishou_video(id)))
            .then(() => {
                this.$message.success('删除成功');
                this.fetchData(); // 刷新数据以反映删除
            })
            .catch(error => {
                this.$message.error('部分删除失败');
                console.error('批量删除时出错！', error);
            });
            this.tableData = this.tableData.filter(row =>!this.selectedRows.includes(row));
        },
     
        handleDelete(index, row) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                delete_kuaishou_video(row.user_id).then(() => {
                this.$message.success('删除成功');
                this.fetchData(); // 刷新数据以反映删除
            }).catch(error => {
                this.$message.error('删除失败');
                console.error('删除时出错！', error);
            });
        }).catch(() => {});
    },
        handlePageChange(val) {
            this.currentPage = val;
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        resetDateFilter() {
            this.$refs.filterTable.clearFilter('date');
        },
        clearFilter() {
            this.$refs.filterTable.clearFilter();
        },
        formatter(row, column) {
            if (column.prop === '发布时间' || column.prop === '采集时间') {
                return moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss');
            }
            return row[column.prop];
        },
        filterTag(value, row) {
            return row.tag === value;
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        handleSearch() {
            this.filteredTableData = this.tableData.filter(data => {
                return Object.values(data).some(value => {
                    return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
                });
            });
        }
    }
}
</script>

<style lang="stylus">
.top-actions
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px

.search-container
    margin-left: auto

.button-container
    margin-right: auto

.advanced-search-fields {
    margin-bottom: 10px;
}


</style>